import React from 'react';

interface ExitConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ExitConfirmationModal: React.FC<ExitConfirmationModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-md w-full p-6 md:p-8">
        {/* Warning Icon */}
        <div className="mx-auto mb-4 w-14 h-14 md:w-16 md:h-16 bg-yellow-100 rounded-full flex items-center justify-center">
          <svg
            className="w-8 h-8 md:w-10 md:h-10 text-yellow-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>

        <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 text-center">
          Exit Onboarding?
        </h2>
        <p className="text-sm md:text-base text-gray-600 mb-6 text-center">
          Your progress will not be saved and your account will not be created. You will be returned to the home page. Are you sure you want to leave?
        </p>

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 bg-gray-100 text-gray-700 py-2.5 md:py-3 px-4 md:px-6 rounded-lg font-medium hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 transition-colors text-sm md:text-base"
          >
            Stay
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 bg-red-600 text-white py-2.5 md:py-3 px-4 md:px-6 rounded-lg font-medium hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-colors text-sm md:text-base"
          >
            Leave
          </button>
        </div>
      </div>
    </div>
  );
};

